import { fontStyles, fontWeights } from "../../tokens/typography";
import { body1Styles, body2Styles, body3Styles, header1Styles, header2Styles, header3Styles, header4Styles, header5Styles, smallBody1Styles, smallBody2Styles, smallHeader1Styles, smallHeader2Styles, smallHeader3Styles, smallHeader4Styles, smallHeader5Styles, } from "../../presets/typography";
import { v2Colors } from "../../tokens/color";
import { breakpoints } from "../../tokens/size";
const defaultTypographyStyles = {
    overflowWrap: 'break-word',
    margin: 0,
    fontStyle: fontStyles.normal,
};
const defaultHeadingStyles = Object.assign(Object.assign({}, defaultTypographyStyles), { color: v2Colors.text.primary, fontWeight: fontWeights.bold });
const defaultBodyStyles = Object.assign(Object.assign({}, defaultTypographyStyles), { color: v2Colors.text.secondary, fontWeight: fontWeights.regular });
export const typographyStyles = {
    header1: Object.assign(Object.assign(Object.assign({}, defaultHeadingStyles), header1Styles), { [`@media (max-width: ${breakpoints.sm})`]: Object.assign({}, smallHeader1Styles) }),
    header2: Object.assign(Object.assign(Object.assign({}, defaultHeadingStyles), header2Styles), { [`@media (max-width: ${breakpoints.sm})`]: Object.assign({}, smallHeader2Styles) }),
    header3: Object.assign(Object.assign(Object.assign({}, defaultHeadingStyles), header3Styles), { [`@media (max-width: ${breakpoints.sm})`]: Object.assign({}, smallHeader3Styles) }),
    header4: Object.assign(Object.assign(Object.assign({}, defaultHeadingStyles), header4Styles), { [`@media (max-width: ${breakpoints.sm})`]: Object.assign({}, smallHeader4Styles) }),
    header5: Object.assign(Object.assign(Object.assign({}, defaultHeadingStyles), header5Styles), { [`@media (max-width: ${breakpoints.sm})`]: Object.assign({}, smallHeader5Styles) }),
    body1: Object.assign(Object.assign(Object.assign({}, defaultBodyStyles), body1Styles), { [`@media (max-width: ${breakpoints.sm})`]: Object.assign({}, smallBody1Styles) }),
    body2: Object.assign(Object.assign(Object.assign({}, defaultBodyStyles), body2Styles), { [`@media (max-width: ${breakpoints.sm})`]: Object.assign({}, smallBody2Styles) }),
    body3: Object.assign(Object.assign({}, defaultBodyStyles), body3Styles),
};
export const variantStyleMapping = {
    h1: typographyStyles.header1,
    h2: typographyStyles.header2,
    h3: typographyStyles.header3,
    h4: typographyStyles.header4,
    h5: typographyStyles.header5,
    body1: typographyStyles.body1,
    body2: typographyStyles.body2,
    body3: typographyStyles.body3,
};
